var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"electron-technology"},[_c('s-r-m-header',{ref:"header"}),_c('IndustryDesc',{ref:"industryDesc",attrs:{"industryInfo":_vm.industryInfo,"show-menu":""}}),_c('ProjectDesc',{attrs:{"descInfo":{
      title: '电子高科技行业特征',
      description: '璞华易研PLM提供适用于电子科技行业的研发管理解决方案',
      redContent: '电子高科技行业',
      content: '的研发业务具有创新性、跨学科性、高投入性、高风险性、紧密的产业合作以及法规与政策影响等特征。这些特征使得企业在研发过程中需要综合考虑多种因素，以实现技术创新和可持续发展。璞华易研PLM提供的数据管理和协作平台，从创新、需求、产品、文档、变更、测试、缺陷、质量、工艺、成本、合规等环节，为电子高科技行业提供了全方位的解决方案，有助于企业在激烈的市场竞争中保持领先地位。'
    }}}),_c('ProblemSolving'),_c('app-benefits',{ref:"appBenefits"}),_c('CompanyInfo',{attrs:{"projectInfo":_vm.projectInfo}}),_c('ResultsOperation',{attrs:{"descInfo":{
      title: '运营效果',
      descArr1: [
        '建立单一数据源提升数据重用率，降低物料种类和直接物料成本。',
        '流程贯穿整个业务系统，消除系统间信息传递的盲点，打通部门墙。',
        '实现公司数据的标准化管理，包括分类、编码、属性等从而减少数据混乱。',
        '研发资料统一管理，保证智力资产的安全。',
        '签核流程电子化，变更单无需每天来往送批。'
      ],
      descArr2: [
        '送审资料快速收集。',
        'PLM数据发行自动传送到ERP，研发数据准确及时给生产和采购。',
        '在系统中完成项目工作分解，任务分派自动通知各工程师。即时评审交付件。',
        '实现设计软件MCAD/Pads集成，加速设计效率，保证数据源一致性。',
      ]
    }}}),_c('ChooseUs',{attrs:{"nameVals":['electron']}}),_c('custom-form',{ref:"customForm"}),_c('footer-box')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }